'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TagsContainer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icons = require('./Icons');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tag = (0, _react.memo)(function (_ref) {
	var icon = _ref.icon,
	    value = _ref.value,
	    label = _ref.label,
	    onClick = _ref.onClick,
	    onClickDelete = _ref.onClickDelete,
	    className = _ref.className,
	    disabled = _ref.disabled,
	    theme = _ref.theme,
	    shape = _ref.shape;


	var onClickTag = function onClickTag() {
		if (!onClick) return;

		onClick(value);
	};

	var onClickDeleteTag = function onClickDeleteTag() {
		if (!onClickDelete) return;

		onClickDelete(value);
	};

	return _react2.default.createElement(
		'li',
		{ className: (0, _classnames2.default)('bnc_tag', 'bnc_tag--theme--' + theme, 'bnc_tag--shape--' + shape, className, {
				'bnc_tag--disabled': disabled || !onClick && !onClickDelete,
				'bnc_tag--no-delete': !onClickDelete,
				'bnc_tag--clickable': !!onClick
			})
		},
		_react2.default.createElement(
			'button',
			{
				className: (0, _classnames2.default)({
					'no-click': !onClick
				}),
				onClick: onClickTag,
				disabled: disabled
			},
			icon,
			' ',
			label
		),
		!disabled && onClickDelete && _react2.default.createElement(
			'span',
			{ className: 'bnc_tag_close', role: 'button', onClick: onClickDeleteTag },
			_react2.default.createElement(_Icons.Close, null)
		)
	);
});

Tag.defaultProps = {
	icon: null,
	label: '',
	onClick: null,
	onClickDelete: null,
	className: '',
	disabled: false,
	theme: 'navy',
	shape: 'square'
};

Tag.propTypes = {
	icon: _utils.StringOrReact,
	label: _utils.StringOrReact,
	onClick: _propTypes2.default.func,
	onClickDelete: _propTypes2.default.func,
	className: _propTypes2.default.string,
	disabled: _propTypes2.default.bool,
	theme: _propTypes2.default.string,
	shape: _propTypes2.default.string
};

var TagsContainer = exports.TagsContainer = function TagsContainer(_ref2) {
	var children = _ref2.children,
	    className = _ref2.className;
	return _react2.default.createElement(
		'ul',
		{ className: (0, _classnames2.default)('bnc_tags_container', className) },
		children
	);
};

exports.default = Tag;